import React from "react";

interface IconButtonProps {
  icon: React.ReactNode;
  action: () => void;
}

const IconButton: React.FC<IconButtonProps> = ({ icon, action }) => {
  return (
    <button className="bg-gray-100 rounded-xl p-3 hover:bg-gray-200" onClick={action}>
      {icon}
    </button>
  );
};

export default IconButton;
